import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios';

//Adding layouts router.
const BlankLayout = () => import("@/layouts/BlankLayout")
const Layout1 = () => import("@/layouts/backend/Layout-1")
const Layout2 = () => import("@/layouts/backend/Layout-2")
const Layout3 = () => import("@/layouts/backend/Layout-3")

//Adding page content router.
const Dashboard = () => import('@/views/backend/Dashboards/Dashboard')

//main pages
const Files = () => import('@/views/backend/CloudBox/Files')
const Folders = () => import('@/views/backend/CloudBox/Folder')
// const Recent = () =>import('@/views/backend/CloudBox/Recent')
// const Favourite = () =>import('@/views/backend/CloudBox/Favourite')
// const Trash = () =>import('@/views/backend/CloudBox/Trash')

//drive pages
// const Alexworkshop = () =>import('@/views/backend/MyDrive/Alexworkshop')
// const Android = () =>import('@/views/backend/MyDrive/Android')
// const Brightspot = () =>import('@/views/backend/MyDrive/Brightspot')
// const IonicChatApp = () =>import('@/views/backend/MyDrive/IonicChatApp')

//widget pages
// const WidgetSimple = () => import('@/views/backend/Widgets/WidgetSimple')
// const WidgetChart = () => import('@/views/backend/Widgets/WidgetChart')

//ui elements
// const UiAlerts = () => import('@/views/backend/Ui/UiAlerts')
// const UiAvatars = () => import('@/views/backend/Ui/UiAvatars')
// const UiBadges = () => import('@/views/backend/Ui/UiBadges')
// const UiBoxShadows = () => import('@/views/backend/Ui/UiBoxShadows')
// const UiBreadcrumbs = () => import('@/views/backend/Ui/UiBreadcrumbs')
// const UiButtonGroups = () => import('@/views/backend/Ui/UiButtonGroups')
// const UiButtons = () => import('@/views/backend/Ui/UiButtons')
// const UiCards = () => import('@/views/backend/Ui/UiCards')
// const UiCarousels = () => import('@/views/backend/Ui/UiCarousels')
// const UiColors = () => import('@/views/backend/Ui/UiColors')
// const UiEmbed = () => import('@/views/backend/Ui/UiEmbed')
// const UiGrids = () => import('@/views/backend/Ui/UiGrids')
// const UiHelperClasses = () => import('@/views/backend/Ui/UiHelperClasses')
// const UiImages = () => import('@/views/backend/Ui/UiImages')
// const UiListGroups = () => import('@/views/backend/Ui/UiListGroups')
// const UiMediaObjects = () => import('@/views/backend/Ui/UiMediaObjects')
// const UiModals = () => import('@/views/backend/Ui/UiModals')
// const UiNotifications = () => import('@/views/backend/Ui/UiNotifications')
// const UiPaginations = () => import('@/views/backend/Ui/UiPaginations')
// const UiPopOvers = () => import('@/views/backend/Ui/UiPopOvers')
// const UiProgressBars = () => import('@/views/backend/Ui/UiProgressBars')
// const UiTabs = () => import('@/views/backend/Ui/UiTabs')
// const UiTooltips = () => import('@/views/backend/Ui/UiTooltips')
// const UiTypography = () => import('@/views/backend/Ui/UiTypography')

//Form elements
// const Checkbox = () => import('@/views/backend/Forms/Form Controls/Checkbox')
// const Elements = () => import('@/views/backend/Forms/Form Controls/Elements')
// const Inputs = () => import('@/views/backend/Forms/Form Controls/Inputs')
// const Radio = () => import('@/views/backend/Forms/Form Controls/Radio')
// const Switch = () => import('@/views/backend/Forms/Form Controls/Switch')
// const TextArea = () => import('@/views/backend/Forms/Form Controls/TextArea')
// const Validations = () => import('@/views/backend/Forms/Form Controls/Validations')
// const Datepicker = () => import('@/views/backend/Forms/Form widget/Datepicker')
// const Fileupload = () => import('@/views/backend/Forms/Form widget/Fileupload')
// const FormQuill = () => import('@/views/backend/Forms/Form widget/FormQuill')
// const SelectComponents = () => import('@/views/backend/Forms/Form widget/SelectComponents')
// const Simple = () => import('@/views/backend/Forms/Form Wizard/Simple')
// const Validate = () => import('@/views/backend/Forms/Form Wizard/Validate')
// const Vertical = () => import('@/views/backend/Forms/Form Wizard/Vertical')

//table elements
// const BasicTable = () => import('@/views/backend/Table/BasicTable')
// const DataTable = () => import('@/views/backend/Table/DataTable')
// const EditTable = () => import('@/views/backend/Table/EditTable')

//icon elements
// const Dripicons = () => import('@/views/backend/Icons/Dripicons')
// const FontAwsome = () => import('@/views/backend/Icons/FontAwsome')
// const LineAwsome = () => import('@/views/backend/Icons/LineAwsome')
// const Remixicons = () => import('@/views/backend/Icons/Remixicons')

//chart elements
// const AmChart = () => import('@/views/backend/Chart/AmChart')
// const ApexChart = () => import('@/views/backend/Chart/ApexChart')
// const HighChart = () => import('@/views/backend/Chart/HighChart')
// const MorrisChart = () => import('@/views/backend/Chart/MorrisChart')

//auth elements
const SignIn = () => import('@/views/backend/Auth/SignIn')
// const SignUp = () => import('@/views/backend/Auth/SignUp')
// const RecoverPassword = () => import('@/views/backend/Auth/RecoverPassword')
// const LockScreen = () => import('@/views/backend/Auth/LockScreen')
// const ConfirmMail = () => import('@/views/backend/Auth/ConfirmMail')

//pages elements
// const ContactDetails = () => import('@/views/backend/Pages/Contact/ContactDetails')
// const ContactList = () => import('@/views/backend/Pages/Contact/ContactList')
// const Pricing1 = () => import('@/views/backend/Pages/Pricing/Pricing1')
// const Pricing2 = () => import('@/views/backend/Pages/Pricing/Pricing2')
// const Pricing3 = () => import('@/views/backend/Pages/Pricing/Pricing3')
// const Pricing4 = () => import('@/views/backend/Pages/Pricing/Pricing4')
// const Timeline1 = () => import('@/views/backend/Pages/Timeline/Timeline1')
// const Timeline2 = () => import('@/views/backend/Pages/Timeline/Timeline2')
// const Timeline3 = () => import('@/views/backend/Pages/Timeline/Timeline3')
// const Timeline4 = () => import('@/views/backend/Pages/Timeline/Timeline4')
const Error404 = () => import('@/views/backend/Pages/Error/Error404')
const Error500 = () => import('@/views/backend/Pages/Error/Error500')
// const BlankPage = () => import('@/views/backend/Pages/BlankPage')
const CommingSoon = () => import('@/views/backend/Pages/CommingSoon')
// const FAQ = () => import('@/views/backend/Pages/FAQ')
// const Invoice = () => import('@/views/backend/Pages/Invoice')
const Maintainance = () => import('@/views/backend/Pages/Maintainance')
// const Subsribers = () => import('@/views/backend/Pages/Subsribers')
const GameLibrary = () => import('@/views/backend/Pages/GameLibrary')
const GameDetail = () => import('@/views/backend/Pages/GameDetail')
const ArcadeLibrary = () => import('@/views/backend/Pages/ArcadeLibrary')
const ArcadeDetail = () => import('@/views/backend/Pages/ArcadeDetail')
const ApiDocument = () => import('@/views/backend/Pages/ApiDocument')
const CompanyProfile = () => import('@/views/backend/Pages/CompanyProfile')
const SlotWinningVideo = () => import('@/views/backend/Pages/SlotWinningVideo')
const ArcadeWinningVideo = () => import('@/views/backend/Pages/ArcadeWinningVideo')
const ArcadeFiles = () => import('@/views/backend/Pages/ArcadeFiles')
const SlotRoadmap = () => import('@/views/backend/Pages/SlotRoadmap')
const ArcadeRoadmap = () => import('@/views/backend/Pages/ArcadeRoadmap')

//fishing
const FishingDetail = () => import('@/views/backend/Pages/FishingDetail')
const FishingLibrary = () => import('@/views/backend/Pages/FishingLibrary')
const FishingFiles = () => import('@/views/backend/Pages/FishingFiles')

//fast
const FastDetail = () => import('@/views/backend/Pages/FastDetail')
const FastLibrary = () => import('@/views/backend/Pages/FastLibrary')
const FastFiles = () => import('@/views/backend/Pages/FastFiles')

//app element
// const EmailComposes = () =>import('@/views/backend/App/Mail/EmailComposes')
// const EmailListing = () =>import('@/views/backend/App/Mail/EmailListing')
// const UserAccountSetting = () =>import('@/views/backend/App/User Management/UserAccountSetting')
const UserAdd = () => import('@/views/backend/App/User Management/UserAdd')
const UserEdit = () => import('@/views/backend/App/User Management/UserEdit')
const UserList = () => import('@/views/backend/App/User Management/UserList')
// const UserProfile = () =>import('@/views/backend/App/User Management/UserProfile')
// const userPrivacySettings = () =>import('@/views/backend/App/User Management/UserPrivacySetting')
// const UserProfileEdit = () =>import('@/views/backend/App/User Management/UserProfileEdit')
// const Chat = () =>import('@/views/backend/App/Chat')
// const Todo = () =>import('@/views/backend/App/Todo')

// const Accountsetting =() =>import('@/views/backend/App/Extraap/AccountSettings')
// const privacypolicy = () =>import('@/views/backend/App/Extraap/PrivacyPolicy')
// const PrivacySettings = () =>import('@/views/backend/App/Extraap/PrivacySettings')
// const TermsOfUse = () =>import('@/views/backend/App/Extraap/TermsOfUse')

const RoleList = () => import('@/views/backend/App/Role Management/RoleList')
const RoleAdd = () => import('@/views/backend/App/Role Management/RoleAdd')
const RoleEdit = () => import('@/views/backend/App/Role Management/RoleEdit')

const TagList = () => import('@/views/backend/App/Tags/TagList')
const TagAdd = () => import('@/views/backend/App/Tags/TagAdd')
const TagEdit = () => import('@/views/backend/App/Tags/TagEdit')

const GameList = () => import('@/views/backend/App/Game/GameList');
const GameAdd = () => import('@/views/backend/App/Game/GameAdd');
const GameEdit = () => import('@/views/backend/App/Game/GameEdit');

const NewsAdd = () => import('@/views/backend/App/News/NewsAdd');
const NewsList = () => import('@/views/backend/App/News/NewsList');
const NewsEdit = () => import('@/views/backend/App/News/NewsEdit');
const NewsDetail = () => import('@/views/backend/App/News/NewsDetail');

const AnnouncementAdd = () => import('@/views/backend/App/Announcement/Announcement');
const AnnouncementList = () => import('@/views/backend/App/Announcement/AnnouncementList');
const AnnouncementEdit = () => import('@/views/backend/App/Announcement/AnnouncementEdit');
// const NewsDetail = () => import('@/views/backend/App/News/NewsDetail');


const config = require("../../config");

Vue.use(VueRouter)
// Vue.use(VueAxios, axios)

const childRoute = () => [
  {
    path: '',
    name: 'layout.dashboard1',
    meta: { name: 'dashboard', requiresAuth: true, uid: 1 },
    component: Dashboard
  },
  {
    path: 'files',
    name: 'layout.files',
    meta: { name: 'files', requiresAuth: true, uid: 45 },
    component: Files
  },
  {
    path: 'api-document',
    name: 'pages.api-document',
    meta: { name: 'api-document', requiresAuth: true, uid: 6 },
    component: ApiDocument
  },
  {
    path: 'company-profile',
    name: 'pages.company-profile',
    meta: { name: 'company-profile', requiresAuth: true, uid: 10 },
    component: CompanyProfile
  },
]

const userchildRoute = () => [
  {
    path: 'list',
    name: 'app.user-list',
    meta: { name: 'user-list', requiresAuth: true, uid: 21 },
    component: UserList
  },
  {
    path: 'add',
    name: 'app.user-add',
    meta: { name: 'user-add', requiresAuth: true, uid: 22 },
    component: UserAdd
  },
  {
    path: 'edit',
    name: 'app.user-edit',
    meta: { name: 'user-edit', requiresAuth: true, uid: 23 },
    component: UserEdit
  }
]

const newschildRoute = () => [

  {
    path: 'list',
    name: 'app.news-list',
    meta: { name: 'news-list', requiresAuth: true, uid: 86 },
    component: NewsList
  },
  {
    path: 'add',
    name: 'app.news-add',
    meta: { name: 'news-add', requiresAuth: true, uid: 84 },
    component: NewsAdd
  },
  {
    path: 'edit',
    name: 'app.news-edit',
    meta: { name: 'news-edit', requiresAuth: true, uid: 87 },
    component: NewsEdit
  },
  {
    path: 'detail',
    name: 'app.news-detail',
    meta: { name: 'news-detail', requiresAuth: true, uid: 88 },
    component: NewsDetail
  },
  // {
  //   path: 'edit',
  //   name: 'app.user-edit',
  //   meta: {  name: 'user-edit', requiresAuth: true, uid: 23 },
  //   component:UserEdit
  // }
]

const announcementchildRoute = () => [

  {
    path: 'list',
    name: 'app.announcement-list',
    meta: { name: 'announcement-list', requiresAuth: true, uid: 111 },
    component: AnnouncementList
  },
  {
    path: 'add',
    name: 'app.announcement-add',
    meta: { name: 'announcement-add', requiresAuth: true, uid: 112 },
    component: AnnouncementAdd
  },
  {
    path: 'edit',
    name: 'app.announcement-edit',
    meta: { name: 'announcement-edit', requiresAuth: true, uid: 113 },
    component: AnnouncementEdit
  },
  // {
  //   path: 'detail',
  //   name: 'app.news-detail',
  //   meta: {  name: 'news-detail', requiresAuth: true, uid: 88 },
  //   component: NewsDetail
  // },
  // {
  //   path: 'edit',
  //   name: 'app.user-edit',
  //   meta: {  name: 'user-edit', requiresAuth: true, uid: 23 },
  //   component:UserEdit
  // }
]

const rolechildRoute = () => [
  {
    path: 'list',
    name: 'app.role-list',
    meta: { name: 'role-list', requiresAuth: true, uid: 31 },
    component: RoleList
  },
  {
    path: 'add',
    name: 'app.role-add',
    meta: { name: 'role-add', requiresAuth: true, uid: 32 },
    component: RoleAdd
  },
  {
    path: 'edit/:id',
    name: 'app.role-edit',
    meta: { name: 'role-edit', requiresAuth: true, uid: 33 },
    component: RoleEdit
  },
]

const tagchildRoute = () => [
  {
    path: 'list',
    name: 'app.tag-list',
    meta: { name: 'tag-list', requiresAuth: true, uid: 71 },
    component: TagList
  },
  {
    path: 'add',
    name: 'app.tag-add',
    meta: { name: 'tag-add', requiresAuth: true, uid: 72 },
    component: TagAdd
  },
  {
    path: 'edit/:name',
    name: 'app.tag-edit',
    meta: { name: 'tag-edit', requiresAuth: true, uid: 73 },
    component: TagEdit
  },
]

const gamechildRoute = () => [
  {
    path: 'list',
    name: 'app.game-list',
    meta: { name: 'game-list', requiresAuth: true, uid: 81 },
    component: GameList
  },
  {
    path: 'add',
    name: 'app.game-add',
    meta: { name: 'game-add', requiresAuth: true, uid: 82 },
    component: GameAdd
  },
  {
    path: 'edit/:gamecode',
    name: 'app.game-edit',
    meta: { name: 'game-edit', requiresAuth: true, uid: 83 },
    component: GameEdit
  }
]

const slotschildRoute = () => [
  {
    path: 'game-library',
    name: 'pages.game-library',
    meta: { name: 'slots-game-library', requiresAuth: true, uid: 41 },
    component: GameLibrary
  },
  {
    path: 'game-detail',
    name: 'pages.game-detail',
    meta: { name: 'slots-game-detail', requiresAuth: true, uid: 42 },
    component: GameDetail
  },
  {
    path: 'media-pack',
    name: 'layout.folders',
    meta: { name: 'slots-media-pack', requiresAuth: true, uid: 46 },
    component: Folders
  },
  {
    path: 'winning-video',
    name: 'pages.slot-winning-video',
    meta: { name: 'slots-winning-video', requiresAuth: true, uid: 43 },
    component: SlotWinningVideo
  },
  {
    path: 'slots-roadmap',
    name: 'pages.slots-roadmap',
    meta: { name: 'slots-roadmap', requiresAuth: true, uid: 89 },
    component: SlotRoadmap
  },

]

const arcadechildRoute = () => [
  {
    path: 'game-library',
    name: 'pages.arcade-library',
    meta: { name: 'arcade-game-library ', requiresAuth: true, uid: 51 },
    component: ArcadeLibrary
  },
  {
    path: 'game-detail',
    name: 'pages.arcade-detail',
    meta: { name: 'arcade-game-detail ', requiresAuth: true, uid: 52 },
    component: ArcadeDetail
  },
  {
    path: 'media-pack',
    name: 'layout.arcadefiles',
    meta: { name: 'arcade-media-pack', requiresAuth: true, uid: 53 },
    component: ArcadeFiles
  },
  {
    path: 'winning-video',
    name: 'pages.arcade-winning-video',
    meta: { name: 'arcade-winning-video ', requiresAuth: true, uid: 54 },
    component: ArcadeWinningVideo
  },
  {
    path: 'arcade-roadmap',
    name: 'pages.arcade-roadmap',
    meta: { name: 'arcade-roadmap', requiresAuth: true, uid: 90 },
    component: ArcadeRoadmap
  },
]

const fishingchildRoute = () => [
  {
    path: 'game-library',
    name: 'pages.fishing-library',
    meta: { name: 'fishing-game-library ', requiresAuth: true, uid: 121 },
    component: FishingLibrary
  },
  {
    path: 'game-detail',
    name: 'pages.fishing-detail',
    meta: { name: 'fishing-game-detail ', requiresAuth: true, uid: 122 },
    component: FishingDetail
  },
  {
    path: 'media-pack',
    name: 'layout.fishingfiles',
    meta: { name: 'fishing-media-pack', requiresAuth: true, uid: 123 },
    component: FishingFiles
  },

]

const fastchildRoute = () => [
  {
    path: 'game-library',
    name: 'pages.fast-library',
    meta: { name: 'fast-game-library ', requiresAuth: true, uid: 131 },
    component: FastLibrary
  },
  {
    path: 'game-detail',
    name: 'pages.fast-detail',
    meta: { name: 'fast-game-detail ', requiresAuth: true, uid: 132 },
    component: FastDetail
  },
  {
    path: 'media-pack',
    name: 'layout.fastfiles',
    meta: { name: 'fast-media-pack', requiresAuth: true, uid: 133 },
    component: FastFiles
  },

]

const authchildRoute = () => [
  {
    path: 'sign-in',
    name: 'auth.login',
    meta: { name: 'signin' },
    component: SignIn
  },
  // {
  //   path: 'recover-password',
  //   name: 'auth.recover-password',
  //   meta: {  name: 'Recover Password' },
  //   component: RecoverPassword
  // },
  // {
  //   path: 'lock-screen',
  //   name: 'auth.lock-screen',
  //   meta: {  name: 'Lock Screen' },
  //   component: LockScreen
  // },
  // {
  //   path: 'confirm-mail',
  //   name: 'auth.confirm-mail',
  //   meta: {  name: 'Confirm Mail' },
  //   component: ConfirmMail
  // },
]

const pageschildRoute = () => [
  {
    path: 'error-404',
    name: 'error.404',
    meta: { name: 'Error 404' },
    component: Error404
  },
  {
    path: 'error-500',
    name: 'error.500',
    meta: { name: 'Error 500' },
    component: Error500
  },
  {
    path: 'pages-maintainance',
    name: 'pages.maintenance',
    meta: { name: 'Maintaiance' },
    component: Maintainance
  },
  {
    path: 'pages-commingsoon',
    name: 'pages.commingsoon',
    meta: { name: 'Comming Soon' },
    component: CommingSoon
  }
]

const extrapageschildRoute = () => [
  // {
  //   path: 'contact-detail',
  //   name: 'contact.detail',
  //   meta: {  name: 'Contact Detail' },
  //   component: ContactDetails
  // },
  // {
  //   path: 'contact-list',
  //   name: 'contact.list',
  //   meta: {  name: 'Contact List' },
  //   component: ContactList
  // },
  // {
  //   path: 'timeline-1',
  //   name: 'time.line',
  //   meta: {  name: 'TimeLine-1' },
  //   component: Timeline1
  // },
  // {
  //   path: 'timeline-2',
  //   name: 'time.line1',
  //   meta: {  name: 'TimeLine-2' },
  //   component: Timeline2
  // },
  // {
  //   path: 'timeline-3',
  //   name: 'time.line2',
  //   meta: {  name: 'TimeLine-3' },
  //   component: Timeline3
  // },
  // {
  //   path: 'timeline-4',
  //   name: 'time.line3',
  //   meta: {  name: 'TimeLine-4' },
  //   component: Timeline4
  // },
  // {
  //   path: 'pricing-1',
  //   name: 'price.pay',
  //   meta: {  name: 'Pricing-1' },
  //   component: Pricing1
  // },
  // {
  //   path: 'pricing-2',
  //   name: 'price.pay1',
  //   meta: {  name: 'Pricing-2' },
  //   component: Pricing2
  // },
  // {
  //   path: 'pricing-3',
  //   name: 'price.pay2',
  //   meta: {  name: 'Pricing-3' },
  //   component: Pricing3
  // },
  // {
  //   path: 'pricing-4',
  //   name: 'price.pay3',
  //   meta: {  name: 'Pricing-4' },
  //   component: Pricing4
  // },
  // {
  //   path: 'pages-invoice',
  //   name: 'pages.invoices',
  //   meta: {  name: 'Pages Invoice' },
  //   component: Invoice
  // },
  // {
  //   path: 'pages-subscriber',
  //   name: 'pages.subscribers',
  //   meta: {  name: 'Pages Subscribers' },
  //   component: Subsribers
  // },
  // {
  //   path: 'pages-faq',
  //   name: 'pages.faq',
  //   meta: {  name: 'Pages FAQ' },
  //   component: FAQ
  // },
  // {
  //   path: 'pages-blank-page',
  //   name: 'pages.blank-page',
  //   meta: {  name: 'Pages Blank Page ' },
  //   component: BlankPage
  // },
  // {
  //   path: 'pages-coming-soon',
  //   name: 'pages.coming-soon',
  //   meta: {  name: 'Pages Coming Soon ' },
  //   component: CommingSoon
  // },
]

const routes = [
  {
    path: '/',
    name: '',
    component: Layout1,
    children: childRoute()
  },
  {
    path: '',
    name: 'layout-2',
    component: Layout2,
    children: [
    ]
  },
  {
    path: '',
    name: 'layout-3',
    component: Layout3,
    children: [
    ]
  },
  {
    path: '/news',
    name: 'news',
    component: Layout1,
    children: newschildRoute()
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: Layout1,
    children: announcementchildRoute()
  },
  {
    path: '/user',
    name: 'user',
    component: Layout1,
    children: userchildRoute()
  },
  {
    path: '/role',
    name: 'role',
    component: Layout1,
    children: rolechildRoute()
  },
  {
    path: '/tags',
    name: 'tag',
    component: Layout1,
    children: tagchildRoute()
  },
  {
    path: '/slots',
    name: 'slots',
    component: Layout1,
    children: slotschildRoute()
  },
  {
    path: '/arcade',
    name: 'arcade',
    component: Layout1,
    children: arcadechildRoute()
  },
  {
    path: '/fishing',
    name: 'fishing',
    component: Layout1,
    children: fishingchildRoute()
  },
  {
    path: '/fast',
    name: 'fast',
    component: Layout1,
    children: fastchildRoute()
  },
  {
    path: '/games',
    name: 'game',
    component: Layout1,
    children: gamechildRoute()
  },
  {
    path: '/auth',
    name: 'auth',
    component: BlankLayout,
    children: authchildRoute()
  },
  {
    path: '/pages',
    name: 'pages',
    component: BlankLayout,
    children: pageschildRoute()
  },
  {
    path: '/extra-pages',
    name: 'extra-pages',
    component: Layout1,
    children: extrapageschildRoute()
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (localStorage.getItem('token') == null) {
        return next({
          path: "/auth/sign-in",
          params: {
            nextUrl: to.fullPath
          }
        });
      }
      else {
        let auth = await axios.get(config.api.URL + '/api/auth/token', { params: {} });
        if (!auth.data.auth) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");

          return next({
            path: "/auth/sign-in",
            params: {
              nextUrl: to.fullPath
            }
          });
        }

        let menuAuth = await axios.get(config.api.URL + '/api/menu/auth', { params: { m: 1 } });
        if (menuAuth.data === true) {
          return next();
        }
        else {
          return next({
            path: "/pages/error-404"
          });
        }
      }
    }
    else {
      if (to.matched === null || to.matched.length == 0) {
        return next({
          path: "/pages/error-404"
        });
      }

      return next();
    }
  } catch (error) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    next({
      path: "/auth/sign-in"
    });
    console.log("Error: ", error);
  }
});

axios.interceptors.request.use(req => {
  let token = localStorage.getItem("token");
  req.params.t = token;

  return req;
});

export default router